import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LayoutContextType {
  isPaddingDisabled: boolean;
  setIsPaddingDisabled: (isDisabled: boolean) => void;
  isTransparent: boolean;
  setIsTransparent: (isTransparent: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [isPaddingDisabled, setIsPaddingDisabled] = useState(false);
  const [isTransparent, setIsTransparent] = useState(false);

  return (
    <LayoutContext.Provider value={{ isPaddingDisabled, setIsPaddingDisabled, isTransparent, setIsTransparent }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
}; 